import { ActionIcon, Box, Group } from "@mantine/core";
import { IconArrowLeft, IconX } from "@tabler/icons-react";
import { type PageProps } from "../../NoShow/Common/Common";
import WizardNavigationProgress from "./WizardNavigationProgress";

interface WizardHeaderProps extends PageProps {
  totalPages: number;
  defaultTotalPages: number;
}

export default function WizardHeader({
  setPages,
  pages,
  totalPages,
  closeModal,
  setTotalPages,
  defaultTotalPages,
}: WizardHeaderProps) {
  return (
    <Box p={32}>
      <Group
        justify={
          pages[pages.length - 1] !== "COMPLETED" ? "space-between" : "right"
        }
      >
        {pages[pages.length - 1] !== "COMPLETED" && (
          <>
            <ActionIcon
              disabled={pages.length === 1}
              variant="transparent"
              color="gray"
              onClick={() => {
                setPages(pages.slice(0, pages.length - 1));
                setTotalPages!(defaultTotalPages);
              }}
            >
              <IconArrowLeft width={24} height={24} />
            </ActionIcon>
            <WizardNavigationProgress
              currentPageIndex={pages.length}
              totalPages={totalPages}
            />
          </>
        )}

        <ActionIcon
          variant="transparent"
          color="gray"
          onClick={() => {
            if (closeModal) {
              closeModal();
            }
          }}
        >
          <IconX width={24} height={24} />
        </ActionIcon>
      </Group>
    </Box>
  );
}
